import type { ReactNode } from 'react';

export const symbol_restore_from_trash: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-120q-24.75 0-42.37-17.63Q201-155.25 201-180v-570h-11q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h158q0-13 8.63-21.5 8.62-8.5 21.37-8.5h204q12.75 0 21.38 8.62Q612-822.75 612-810h158q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-11v570q0 24.75-17.62 42.37Q723.75-120 699-120H261Zm438-630H261v570h438v-570Zm-438 0v570-570Zm189 215v166q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-166l59 63q8.5 9 21.25 9t21.75-9q9-9 9-21t-9-21L501-626q-9-9-21-9t-21 9L348-514q-8 9-8.5 21.1-.5 12.1 8.5 20.9 9 9 21.5 8.5T391-473l59-62Z"
		/>
	</svg>
);
